import React from 'react';
import AdminPastPapers from './AdminPastPapers';
import AdminFlashCards from './AdminFlashCards';
import AdminCheatSheets from './AdminCheatSheets';

export default function ResourcesAdminSection({ activeSubSection }: { activeSubSection?: string | null }) {
  // If Resource Management tab is selected but no subsection chosen, render nothing
  // and wait for the user to select a subsection from the sidebar.
  if (!activeSubSection) return null;

  if (activeSubSection === 'past-papers') {
    return <AdminPastPapers />;
  }
  
  if (activeSubSection === 'flash-cards') {
    return <AdminFlashCards />;
  }

  if (activeSubSection === 'cheat-sheets') {
    return <AdminCheatSheets />;
  }

  // If a subsection is selected but it's not implemented yet
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-bold text-slate-800" style={{ fontFamily: "'Inter', sans-serif" }}>Resources</h2>
          <p className="text-slate-500 text-sm">Selected subsection not implemented yet.</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-100 p-8 text-center">
        <div className="w-12 h-12 flex items-center justify-center bg-slate-50 rounded-full mx-auto mb-4">
          <i className="ri-folder-open-line text-slate-600 text-xl"></i>
        </div>
        <p className="text-sm text-slate-600">This subsection will be available when implemented.</p>
      </div>
    </div>
  );
}
